<template>
<div class="chapter">
<div class="inner_page">
<div class="prelims-page" id="df42f5abd977e-d1e204"><span id="pageii">
<h3 class="books-by-head"><em class="char-italic italic">A Selection of Titles from Sarah R. Shaber</em></h3>
<p class="books-by-text-space-after"><em class="char-italic italic">The Professor Simon Shaw Series</em></p>
<p class="books-by-text">SIMON SAID</p>
<p class="books-by-text">SNIPE HUNT</p>
<p class="books-by-text">THE FUGITIVE KING</p>
<p class="books-by-text">THE BUG FUNERAL</p>
<p class="books-by-text-space-after">SHELL GAME</p>
<p class="books-by-text-space-after"><em class="char-italic italic">The Louise Pearlie Series</em></p>
<p class="books-by-text">LOUISE’S WAR *</p>
<p class="books-by-text">LOUISE’S GAMBLE *</p>
<p class="books-by-text">LOUISE’S DILEMMA *</p>
<p class="books-by-text">LOUISE’S BLUNDER *</p>
<p class="books-by-text-space-after">LOUISE’S CHANCE *</p>
<p class="books-by-text"><em class="char-italic italic">* available from Severn House</em></p></span></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781780107158_epub_alb.vue?0171a066